import LocationOnIcon from '@mui/icons-material/LocationOn'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import ChatBubbleOutlineIcon from '@mui/icons-material/Chat'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import ApartmentIcon from '@mui/icons-material/Apartment'
import HandshakeIcon from '@mui/icons-material/Handshake'

// غيّر مسار الصور دي حسب الملفات الموجودة عندك بالظبط في مجلد Images
import contactHeroImage from '../Images/Footer.jpg'
import contactFormImage from '../Images/lyorauralogo.png'

export const contactUsData = {
  hero: {
    eyebrow: { ar: 'تواصل معنا', en: 'Contact Us' },
    title: { ar: 'خلّينا نبدأ رحلتك الاستثمارية', en: "Let's Start Your Investment Journey" },
    subtitle: {
      ar: 'فريقنا جاهز يجاوبك على أي سؤال ويساعدك تلاقي الفرصة العقارية المناسبة ليك في دبي.',
      en: "Our team is ready to answer your questions and help you find the right real estate opportunity in Dubai.",
    },
    image: contactHeroImage,
  },

  // شريط بيانات التواصل السريعة - بنفس شكل شبكة الإحصائيات في صفحة الأباوت
  quickInfo: [
    {
      icon: LocationOnIcon,
      label: { ar: 'العنوان', en: 'Address' },
      // value: { ar: 'كونراد دبي – شارع الشيخ زايد – المركز التجاري الأول – دبي', en: 'Conrad Dubai, Sheikh Zayed Rd - Trade Center First - Dubai' },
    value: {
  ar: '  بنايه وايت سوان شارع الشيخ زايد، الطابق الأول، دبي',
  en: 'WHITE SWAN BUILDING, Sheikh Zayed Road, First Floor, Dubai'
},

    },
    {
      icon: PhoneIcon,
      label: { ar: 'التليفون', en: 'Phone' },
      value: { ar: '+971 58 553 5444', en: '+971585535444' },
      href: 'tel:+971585535444',
    },
    {
      icon: EmailIcon,
      label: { ar: 'البريد الإلكتروني', en: 'Email' },
      value: { ar: 'info@lyorauraproperties.com', en: 'info@lyorauraproperties.com' },
      href: 'mailto:info@lyorauraproperties.com',
    },
    {
      icon: AccessTimeIcon,
      label: { ar: 'أوقات العمل', en: 'Working Hours' },
      value: { ar: 'السبت - الخميس، 9 ص - 7 م', en: 'Sat - Thu, 9 AM - 7 PM' },
    },
  ],

  // سيكشن الفورم - نص وصورة زي سيكشن "قصتنا" في صفحة الأباوت
  formSection: {
    eyebrow: { ar: 'سجل بياناتك', en: 'Register Your Details' },
    title: { ar: 'مستشارينا في انتظارك', en: 'Our Advisors Are Waiting For You' },
    description: {
      ar: 'املأ النموذج وهيتواصل معاك حد من فريقنا خلال 24 ساعة عشان نفهم احتياجاتك ونرشحلك أفضل الفرص الاستثمارية المتاحة.',
      en: 'Fill in the form and one of our team members will reach out within 24 hours to understand your needs and recommend the best investment opportunities available.',
    },
    image: contactFormImage,
  },

  // سيكشن خطوات التواصل - بنفس شكل شبكة "القيم" في صفحة الأباوت
  processSection: {
    eyebrow: { ar: 'إزاي بنشتغل', en: 'How It Works' },
    title: { ar: 'رحلتك معانا في 4 خطوات', en: 'Your Journey With Us in 4 Steps' },
    items: [
      {
        icon: ChatBubbleOutlineIcon,
        title: { ar: 'تواصل معانا', en: 'Reach Out' },
        desc: {
          ar: 'ابعتلنا رسالتك أو اتصل بينا، وهيرد عليك أحد مستشارينا في أسرع وقت.',
          en: 'Send us a message or give us a call, and one of our advisors will respond promptly.',
        },
      },
      {
        icon: EventAvailableIcon,
        title: { ar: 'احجز استشارة', en: 'Book a Consultation' },
        desc: {
          ar: 'هنحدد ميعاد يناسبك نتكلم فيه عن أهدافك وميزانيتك الاستثمارية.',
          en: 'We schedule a time that suits you to discuss your goals and investment budget.',
        },
      },
      {
        icon: ApartmentIcon,
        title: { ar: 'شوف الخيارات', en: 'Explore Options' },
        desc: {
          ar: 'هنعرضلك أفضل المشاريع اللي تناسب معاييرك في أرقى مواقع دبي.',
          en: "We present the best projects that match your criteria in Dubai's finest locations.",
        },
      },
      {
        icon: HandshakeIcon,
        title: { ar: 'وقّع واستثمر', en: 'Sign & Invest' },
        desc: {
          ar: 'نساعدك في كل خطوات التعاقد لحد ما تمتلك وحدتك الجديدة بكل شفافية.',
          en: 'We guide you through every step of the contract until your new unit is fully yours.',
        },
      },
    ],
  },
}